import { AmortizedLoanCalculator } from "../Apps/AmortizedLoanCalculator"

function AppAmortizedLoanCalculator() {

    return (
        <AmortizedLoanCalculator />
    )
}

export default AppAmortizedLoanCalculator

